import React from 'react';
import styled from 'styled-components';
import foodImage from '../assets/img/food-image.png';
import mLogoRed from '../assets/img/m-logo-red.svg';
import TeamLogo from './TeamLogo';

const Wrapper = styled.div`
  position: relative;
  margin: -58px -16px 0;
  height: 100vh;
  background: #db0007;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  overflow-y: hidden;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  padding: 8px 10px 10px;
  z-index: 2;
  flex-shrink: 0;
`;

const LogoImg = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 3;
  flex: 1;
  min-height: 0;
`;

const BurgerImage = styled.img`
  position: relative;
  margin-top: auto;
  width: 100%;
  z-index: 2;
`;

function RedScreenLayout({ children }) {
  return (
    <Wrapper>
      <LogoContainer>
        <LogoImg src={mLogoRed} alt="McDonald's" />
        <TeamLogo />
      </LogoContainer>

      <Content>{children}</Content>

      <BurgerImage src={foodImage} alt="Big Mac" />
    </Wrapper>
  );
}

export default RedScreenLayout;
